export enum Environment
{
    Test = 'test',
    Development = 'development',
    Production = 'production'
}

interface Config
{
    /** The app version */
    version: string;
    /** The app environment. */
    environment: Environment;
    /** The URL of the this Next.js website. */
    appUrl: string;
    /** The GraphQL API URL.  */
    apiUrl: string;
    /** Is the CDN enabled? */
    isCdnEnabled: boolean;
    /** The base URL of the AWS CDN. */
    cdnBaseUrl: string;
    /** The base URL for the /public directory. */
    publicDirBaseUrl: string;
    /** If CDN is enabled, this points to the CDN /public directory, otherwise to the servers's /public directory. */
    defaultPublicDirBaseUrl: string;
    /** A list of available languages. */
    languages: AppLanguage[]
    /** The default languge of the app. */
    defaultLanguage: AppLanguage;
    /** The Google Analytics GTM server container URL (server side tracking). */
    googleAnalyticsServerContainerUrl: string;
    /** The Google Analytics tracking ID. */
    googleAnalyticsId: string;
    /** The legacy Google Universal Analytics tracking ID */
    googleUniversalAnalyticsId?: string;
    /** The Google Ads tracking ID */
    googleAdsId: string;
    /** The Google Ads 'purchase' conversion label. */
    googleAdsPurchaseConversionLabel: string;
    /** The Google Ads 'add to cart' conversion label. */
    googleAdsAddToCartConversionLabel: string;
    /** The Google Ads 'begin checkout' conversion label. */
    googleAdsBeginCheckoutConversionLabel: string;
    /** The Facebook Pixel tracking ID. */
    facebookPixelId: string;
    /** The Facebook App ID. */
    facebookAppId: string;
    /** The Facebook Test Event Code. */
    facebookTestEventCode: string;
    /** The Google API client ID. https://developers.google.com/identity/gsi/web/guides/get-google-api-clientid */
    googleApiClientId: string;
    googleMerchantId: string;
    klaviyoPublicApiKey: string;
    klaviyoNewsLetterListId: string;
}

let environment: Environment = process.env.NODE_ENV as Environment;
let isProduction = environment == Environment.Production;
let isCdnEnabled = parseInt(process.env.NEXT_PUBLIC_CDN_ENABLED as string) == 1;
let languages = [
    { code: 'ro', name: 'Română', locale: 'ro_RO' },
];

let config: Config =
{
    version: process.env.NEXT_PUBLIC_VERSION as string,
    environment: environment,
    appUrl: process.env.NEXT_PUBLIC_APP_URL as string,
    apiUrl: process.env.NEXT_PUBLIC_API_URL as string,
    isCdnEnabled: isCdnEnabled,
    cdnBaseUrl: process.env.NEXT_PUBLIC_CDN_BASE_URL as string,
    publicDirBaseUrl: process.env.NEXT_PUBLIC_APP_URL as string,
    defaultPublicDirBaseUrl: (isProduction && isCdnEnabled ? process.env.NEXT_PUBLIC_CDN_BASE_URL : process.env.NEXT_PUBLIC_APP_URL) as string,
    languages: languages,
    defaultLanguage: languages.find(l => l.code == 'ro')!,
    googleAnalyticsId: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_4_ID as string,
    googleUniversalAnalyticsId: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID as string,
    googleAdsId: process.env.NEXT_PUBLIC_GOOGLE_ADS_ID as string,
    googleAdsPurchaseConversionLabel: process.env.NEXT_PUBLIC_GOOGLE_ADS_PURCHASE_CONVERSION_LABEL as string,
    googleAdsAddToCartConversionLabel: 'LgubCJTNtbgbEKyuveED',
    googleAdsBeginCheckoutConversionLabel: 'DbAVCOjJrbgbEKyuveED',
    googleAnalyticsServerContainerUrl: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_SERVER_CONTAINER_URL as string,
    facebookPixelId: process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID as string,
    facebookAppId: process.env.NEXT_PUBLIC_FACEBOOK_APP_ID as string,
    facebookTestEventCode: '',
    googleApiClientId: process.env.NEXT_PUBLIC_GOOGLE_API_CLIENT_ID as string,
    googleMerchantId: process.env.NEXT_PUBLIC_GOOGLE_MERCHANT_ID as string,
    klaviyoPublicApiKey: process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_API_KEY as string,
    klaviyoNewsLetterListId: process.env.NEXT_PUBLIC_KLAVIYO_NEWSLETTER_LIST_ID as string,
}

export interface Language
{
    /** Language code. Eg: en, hu, ro */
    code: string, 
    /** The name of the language in the given language. */
    name: string,
}

export interface AppLanguage extends Language
{
    /** A language local name. Eg: en_US */
    locale: string,
}

export default config;
